import { batch, computed, signal } from "@preact/signals-react"
import { isEmpty } from "@ui-seeker/utils"


export const alertsDrawerData = signal({})
export const alertsDrawerErrors = signal({})
export const loadingRowId = signal(null)
export const loadingEditRowId = signal(null)

//Computed
export const isAlertsDrawerOpen = computed(() => alertsDrawerData.value && !isEmpty(alertsDrawerData.value))

//Functions

export const clearSignals = () => batch(() => {
	alertsDrawerData.value = {}
	alertsDrawerErrors.value = {}
})